<template>
    <div>
        <HeadCommon></HeadCommon>
        <div class="main">
            <div class="head_bg">
                <img src="../img/contact_us-bg.png" alt="">
                <div class="text">
                    <p style="color: #fff;">新闻中心</p>
                    <span></span>
                </div>
            </div>
            <div class="container">
                <div class="recent">
                    <div class="title">
                        <h2>—— 近期要闻 ——</h2>
                    </div>
                    <div class="flex-aic">
                        <div class="swiper">
                            <img :src="firstItem.img" alt="">
                        </div>
                        <div class="text">
                            <h2>{{ firstItem.title }}</h2>
                            <span>{{ firstItem.show_time }}</span>
                            <p>{{ firstItem.brief }}
                            </p>

                            <router-link :to="{ name: 'NewsInfo', params: { id: firstItem.id } }">
                                <a class="btn" @click="getnewsinfoList(firstItem.id)">查看详情</a>
                            </router-link>
                        </div>
                    </div>
                </div>
                <div class="more_news">
                    <div class="title">
                        <h2>—— 更多新闻 ——</h2>
                    </div>
                    <div class="hot">
                        <router-link :to="'/newsinfo/' + item.id" class="news-hot" v-for="item in secondArray" :key="item.id">
                            <a class="item" @click="getnewsinfoList(item.id)">
                                <div class="img">
                                    <img :src="item.img" alt="">
                                </div>
                                <div class="text">
                                    <span>{{ item.show_time }}</span>
                                    <p class="text-p">{{ item.title }}</p>
                                    
                                </div>
                            </a>
                        </router-link>
                        <!-- <router-link to="/newsinfo" class="news-hot">
                            <a class="item" @click="getnewsinfoList(firstItem.id)">
                                <div class="img">
                                    <img :src="firstItem.img" alt="">
                                </div>
                                <div class="text">
                                    <span>{{ firstItem.show_time }}</span>
                                    <p>{{ firstItem.article }}</p>
                                </div>
                            </a>
                        </router-link>
                        <router-link to="/newsinfo" class="news-hot">
                            <a class="item" @click="getnewsinfoList(firstItem.id)">
                                <div class="img">
                                    <img :src="firstItem.img" alt="">
                                </div>
                                <div class="text">
                                    <span>{{ firstItem.show_time }}</span>
                                    <p>{{ firstItem.article }}</p>
                                </div>
                            </a>
                        </router-link> -->
                    </div>
                    <div class="list">
                        <router-link :to="'/newsinfo/' + item.id" v-for="item in thirdArray" :key="item.id">
                            <a class="item">
                                <div class="img" @click="getnewsinfoList(item.id)">
                                    <img :src="item.img" alt="">
                                </div>
                                <div class="text">
                                    <p class="text-p">{{ item.title }}</p>
                                    <span>{{ item.show_time }}</span>
                                </div>
                            </a>
                        </router-link>

                        <!-- <router-link to="/newsinfo">
                            <a class="item">
                                <div class="img">
                                    <img src="../img/news2.png" alt="">
                                </div>
                                <div class="text">
                                    <p>影墨教育新闻动态影墨教育新闻动态影墨教育新闻动态影墨教育新闻动态影墨教育新闻动态...</p>
                                    <span>2023-05-13 10:12</span>
                                </div>
                            </a>
                        </router-link>
                        <router-link to="/newsinfo">
                            <a class="item">
                                <div class="img">
                                    <img src="../img/news2.png" alt="">
                                </div>
                                <div class="text">
                                    <p>影墨教育新闻动态影墨教育新闻动态影墨教育新闻动态影墨教育新闻动态影墨教育新闻动态...</p>
                                    <span>2023-05-13 10:12</span>
                                </div>
                            </a>
                        </router-link>
                        <router-link to="/newsinfo">
                            <a class="item">
                                <div class="img">
                                    <img src="../img/news1.png" alt="">
                                </div>
                                <div class="text">
                                    <p>影墨教育新闻动态影墨教育新闻动态影墨教育新闻动态影墨教育新闻动态影墨教育新闻动态...</p>
                                    <span>2023-05-13 10:12</span>
                                </div>
                            </a>
                        </router-link> -->
                    </div>
                </div>
            </div>
        </div>
        <FootCommon></FootCommon>
    </div>
</template>
  
<script>
import HeadCommon from '@/components/HeadCommon.vue';
import FootCommon from '@/components/FootCommon.vue';
import { getnewsList } from "@/api/news";
// import store from "@/store";
export default {
    name: 'NewS',
    components: {
        HeadCommon,
        FootCommon
    },
    data() {
        return {
            firstArray: [],
            secondArray: [],
            thirdArray: []
        }
    },
    created() {
        this.getnewsList()
    },
    methods: {
        // 新闻列表
        async getnewsList() {
            const { data } = await getnewsList()
            console.log(data);
             // 第一个数组对象
            this.firstArray = data.slice(0, 1);
             // 第二个数组包含2、3、4对象
            this.secondArray = data.slice(1, 4);
             // 第三个数组为剩下的数据5,6,7...
            this.thirdArray = data.slice(4,Math.min(8, data.length));
        },
        // 在点击新闻列表的时候拿当前页面的id
        // getnewsinfoList(id) {
        //     this.$store.state.pageId = id
        //     console.log(this.$store.state.pageId,'vuex');
        //     }
    },
    computed: {
        // 计算属性获取第一项
        firstItem() {
            if (this.firstArray.length > 0) {
                return this.firstArray[0];
            } else {
                return {}; // 返回一个空对象，防newsList为空
            }
        }
    }
}
</script>
  
<style>
@import '../style/news.css'
</style>






